import React from "react";

function Pricing() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 30 30"
        >
            <path
                fill="#000"
                d="M15.002 15.803a4.757 4.757 0 01-4.752-4.752 4.757 4.757 0 014.752-4.752 4.757 4.757 0 014.752 4.752.82.82 0 11-1.639 0 3.117 3.117 0 00-3.113-3.114 3.117 3.117 0 00-3.113 3.114 3.117 3.117 0 003.113 3.113.82.82 0 110 1.639z"
            ></path>
            <path
                fill="#000"
                d="M15.002 23.67a4.757 4.757 0 01-4.752-4.752.82.82 0 111.639 0 3.117 3.117 0 003.113 3.113 3.117 3.117 0 003.114-3.113 3.117 3.117 0 00-3.114-3.114.82.82 0 110-1.639 4.757 4.757 0 014.752 4.753 4.757 4.757 0 01-4.752 4.752zM14.999 7.937a.82.82 0 01-.82-.819v-3.04a.82.82 0 111.64 0v3.041a.819.819 0 01-.82.818z"
            ></path>
            <path
                fill="#000"
                d="M14.999 26.743a.82.82 0 01-.82-.82v-3.04a.82.82 0 111.64 0v3.04a.82.82 0 01-.82.82z"
            ></path>
            <path
                fill="#000"
                d="M15 30C6.729 30 0 23.27 0 15S6.729 0 15 0s15 6.729 15 15-6.729 15-15 15zm0-28.361C7.632 1.639 1.639 7.632 1.639 15S7.632 28.361 15 28.361 28.361 22.366 28.361 15c0-7.366-5.993-13.361-13.361-13.361z"
            ></path>
        </svg>
    );
}

export default Pricing;
